import React from 'react';
import dogAnimation from '../../animations/jd-dog.json';
import Lottie from 'lottie-react';

function AnimatedImage() {
	return <Lottie className="animation-lottie" animationData={dogAnimation} loop={true} />;
}

export default AnimatedImage;
